import { observer } from 'mobx-react-lite';
import { IPromiseBasedObservable } from 'mobx-utils';
import { ReactElement, ReactNode } from 'react';
import ErrorBox from '../display/ErrorBox';
import LoadingBox from './LoadingBox';
import NoItemsBox from './NoItemsBox';

export default observer(function PromiseContainer<T>({
  children,
  empty = () => <NoItemsBox itemsName={itemsName} sx={{ mt: 2 }} />,
  itemsName,
  pending = () => (
    <LoadingBox>{itemsName && <span>Loading {itemsName}…</span>}</LoadingBox>
  ),
  promise,
  rejected = (e) => <ErrorBox error={e} />,
}: {
  children: ((value: T) => ReactElement) | ReactElement;
  empty?: ((value?: T | void) => ReactElement) | false;
  itemsName?: ReactNode;
  pending?: () => ReactElement;
  promise?: IPromiseBasedObservable<T>;
  rejected?: (error: Error) => ReactElement;
}) {
  if (!promise) {
    return null;
  }

  const { state, value } = promise;
  const anyValue = value as any;

  switch (state) {
    case 'fulfilled': {
      const isEmpty =
        !value ||
        (Array.isArray(value) && value.length === 0) ||
        anyValue?.isEmpty;

      if (isEmpty && typeof empty === 'function') {
        return empty(anyValue);
      }

      return typeof children === 'function' ? children(anyValue) : children;
    }
    case 'pending': {
      return pending();
    }
    case 'rejected': {
      return rejected(anyValue);
    }
    default: {
      return rejected(new Error(`Unknown Resource state ${state}`));
    }
  }
});
